$(() => {
  $('.selected-filters-num').text($('.tag-checkbox-select:checked').length);
  $('.mobile-filter-toggle').on('click', () => {
    $('.filter-options-container').toggleClass('d-none');
    $('.filter-main-container').toggle();
  });
});
